import React from "react";
import RV from "simple-react-validator";
import ls from "local-storage";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import * as CONFIG from "./_config";

toast.configure();
const axios = require("axios");

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];

    this.state = {
      formControls: {},
      stores: [],
      value: [],
      errors: [],
    };
    this.handleChangePassword = this.handleChangePassword.bind(this);
  }

  changeHandler = (event) => {
    //console.log('>>>>>>>>>.working');

    const name = event.target.name;
    const value = event.target.value;
    console.log(this.state);
    this.setState({
      formControls: { ...this.state.formControls, [name]: value },
    });
  };

  changeNumericHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const isNumValue = !isNaN(value) ? value : "";

    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: isNumValue,
      },
    });
  };

  changeCheckboxHandler = (event) => {
    const name = event.target.name;
    const value = event.target.checked ? "1" : "";

    this.setState({
      formControls: { ...this.state.formControls, [name]: value },
    });
  };

  handleChangePassword(e) {
    //  var pattern = new RegExp(/^(?=.*[a-z])(?=.*[0-9])([!@#\$%\^&\*]?)(?=.{6,})/);

    var pattern = new RegExp(/^(?=^.{6,}$)^[a-zA-Z0-9_@./#&+-]*$/);

    if (!!pattern.test(e.target.value)) {
      var error = [];
      error.msg = "";
      error.statusCode = "success";

      this.setState({
        formControls: {
          ...this.state.formControls,
          ["password"]: e.target.value,
        },
        errors: error,
      });
    } else {
      var error = [];
      error.msg = "Password (6-12 characters)";
      error.statusCode = "error";
      this.setState({ errors: error });
    }
  }

  Stores() {
    var ClientStores = ls.get("ClientStores");
    // console.log("storage", ClientStores);

    // if (ClientStores) {
    //   this.setState({ stores: ClientStores });
    // } else {

    const data = new FormData();
    data.append("method", "POST");
    let apiurl = "";

    if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
    } else {
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
    }

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        // console.log('res',res);
        //ls.set("ClientStores", res.data.GetClientStores);
        this.setState({ stores: res.data.GetClientStores });
      })
      .catch(function (response) {
        console.log(response);
      });
    //}
  }

  componentDidMount() {
    if (ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`))
      window.location.href = "/";

    this.Stores();
  }

  Register = async (e) => {
    e.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();

      if (this.state.errors.statusCode === "success") {
        var error = [];
        error.msg = "";
        error.statusCode = "";

        this.setState({ errors: error });
      } else if (this.state.errors.statusCode === "error") {
        var error = [];
        error.msg = "Password (6-12 characters)";
        error.statusCode = "missing";

        this.setState({ errors: error });
      } else {
        var error = [];
        error.msg = "The Password field is required";
        error.statusCode = "missing";
        this.setState({ errors: error });
      }
      return false;
    } else {
      var phone = this.state.formControls
        ? this.state.formControls.phone || ""
        : "";
      var zipCode = this.state.formControls.zipcode
        ? this.state.formControls.zipcode || ""
        : "";
      // console.log(phone);
      const data = new FormData();
      data.append("method", "POST");

      // eslint-disable-next-line no-lone-blocks
      // {
      //     CONFIG.DATA.RSA_SUBDOMAIN === 'brooksgrocery' ||  CONFIG.DATA.RSA_SUBDOMAIN === 'lowesfoodking' ?
      //         data.append('apiurl', `https://qaecrs.rsaamerica.com/Services/SSWebRestApi.svc/Register`) :

      const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/Register`;

      //}

      data.append("UserName", this.state.formControls.username);
      data.append("Password", this.state.formControls.password);
      data.append("FirstName", this.state.formControls.firstname);
      data.append("LastName", this.state.formControls.lastname);
      data.append("DeviceType", "D258B2E7-BA54-4855-B919-1CA28C9F8B57");
      data.append("DeviceId", "2");
      data.append("ZipCode", zipCode);
      data.append("PhoneNumber", phone);

      data.append("CustomerId", 1);
      data.append("ClientStoreId", this.state.formControls.client_store);
      data.append(
        "keys",
        "method,apiurl,UserName,Password,FirstName,LastName,PhoneNumber,DeviceType,DeviceId,ZipCode,CustomerId,ClientStoreId"
      );

      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })
        .then((res) => {
          if (res.data.ErrorMessage.ErrorCode <= 0) {
            toast.error(res.data.ErrorMessage.ErrorDetails);
          } else {
            toast.success("Register Successfully !", { autoClose: 7000 });
            //console.log('res', res); return;

            if (
              CONFIG.DATA.ONLY_COUPONS === true ||
              CONFIG.DATA.BETA_SITE === true
            ) {
              window.location.href = CONFIG.DATA.BASEPATH + "login";
              // window.location.reload()
            } else {
              window.location.href = "/login";
            }
          }
        })
        .catch(function (ress) {
          console.log(ress);
          toast.error("Error Notification !");
        });
    }
  };
  handleChange = (value) => {
    // console.log("Captcha value:", value);
    this.setState({
      formControls: { ...this.state.formControls, ["Captcha"]: value },
    });
  };

  asyncScriptOnLoad = () => {
    // this.setState({ callback: "called!" });
    // console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };

  render() {
    console.log("rsa_subdomain", this.state.errors);
    console.log("length", this.state.errors.length);
    let PhoneMandatory = CONFIG.DATA.IS_PHONE_NUMBER_REQUIRED
      ? "required|"
      : "";

    return (
      <div>
        <div className="main-container full-width pt-2 mt-2  ">
          {CONFIG.DATA.THEME === 2 ? (
            <div>
              {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
                ""
              ) : (
                <section
                  id="apus-breadscrumb"
                  className="breadcrumb-page apus-breadscrumb"
                  style={{ backgroundColor: "#f3ffd9" }}
                >
                  <div className="container">
                    <div className="wrapper-breads">
                      <div className="wrapper-breads-inner">
                        <div className="breadscrumb-inner">
                          <h2 className="bread-title">Register</h2>
                          <ol className="breadcrumb">
                            <li>
                              <a href={CONFIG.DATA.BASEPATH}>Home</a>
                            </li>
                            <li>
                              <span>Register</span>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <div className="title-breadcrumb-inner">
                  <header className="entry-header">
                    <h1 className="entry-title">Register</h1>
                  </header>
                  <div className="breadcrumbs">
                    <Link to="/">Home</Link>
                    <span className="separator">/</span>
                    <span> Register</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
            <>
              <img
                src="/assets/images/food_bazaar_log_n_image.svg"
                style={{ height: "180px" }}
                alt="Foodbazaar"
              />
            </>
          ) : (
            ""
          )}

          <div className="row">
            <div className="col-md-4 offset-md-4 pt-4">
              {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
                <div className="card">
                  <div className="card-body">
                    <h3 style={{ fontWeight: "400" }}>Register</h3>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="page-content border pt-3">
                <div className="container">
                  <article
                    id="post-22"
                    className="post-22 page type-page status-publish hentry"
                  >
                    <div className="entry-content">
                      <div className="at-above-post-page addthis_tool"></div>
                      <div className="woocommerce">
                        <div className="woocommerce-notices-wrapper"></div>

                        <form method="post" className="login">
                          <p className="form-group form-row form-row-wide">
                            <label htmlFor="first_name">
                              First Name <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="input-text form-control"
                              name="firstname"
                              id="firstname"
                              onChange={(e) => this.changeHandler(e)}
                            />
                            <span className="text-danger">
                              {this.validator.message(
                                "first_name",
                                this.state.formControls.firstname,
                                "required|alpha"
                              )}
                            </span>
                          </p>
                          <p className="form-group form-row form-row-wide">
                            <label htmlFor="lastname">
                              Last Name <span className="required">*</span>
                            </label>
                            <input
                              className="input-text form-control"
                              type="text"
                              name="lastname"
                              id="lastname"
                              onChange={(e) => this.changeHandler(e)}
                            />

                            <span className="text-danger">
                              {this.validator.message(
                                "last_name",
                                this.state.formControls.lastname,
                                "required|alpha"
                              )}
                            </span>
                          </p>

                          {CONFIG.DATA.BACKEND_HOST !== "sfoodmart" ? (
                            <p className="form-group form-row form-row-wide">
                              <label htmlFor="zipcode">
                                Zip Code <span className="required">*</span>
                              </label>
                              <input
                                className="input-text form-control"
                                type="text"
                                maxLength="5"
                                name="zipcode"
                                id="zipcode"
                                onChange={(e) => this.changeNumericHandler(e)}
                                value={this.state.formControls.zipcode}
                              />
                              <span className="text-danger">
                                {this.validator.message(
                                  "zipcode",
                                  this.state.formControls.zipcode,
                                  "required|numeric|min:5|max:5"
                                )}
                              </span>
                            </p>
                          ) : (
                            ""
                          )}

                          {CONFIG.DATA.ALLOW_PHONENUMBER ||
                          CONFIG.DATA.BACKEND_HOST === "foodbazaar" ||
                          CONFIG.DATA.BACKEND_HOST === "marketsquare" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesfoodking" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessupersave" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesmarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessignature" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "superiorgrocers" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "market33" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "fiestafoodsamarillo" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "topvaluecostplus" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "pandlcountrymarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN ===
                            "bradfordgeneralstore" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lagreesfoodstores" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "mcdanielpw" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "kirbyfoods" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "vowellsmarketplace" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw" ? (
                            <p className="form-group form-row form-row-wide">
                              <label htmlFor="username">
                                Phone Number
                                {CONFIG.DATA.IS_PHONE_NUMBER_REQUIRED
                                  ? "*"
                                  : "(Optional)"}
                              </label>
                              <input
                                className="input-text form-control"
                                type="numeric"
                                name="phone"
                                maxLength="10"
                                id="phone"
                                inputMode="numeric"
                                onChange={(e) => this.changeHandler(e)}
                              />

                              <span className="text-danger">
                                {this.validator.message(
                                  "phone",
                                  this.state.formControls.phone,
                                  `${PhoneMandatory}numeric|min:0,num`
                                )}
                              </span>
                            </p>
                          ) : (
                            ""
                          )}

                          <p className="form-group form-row form-row-wide">
                            <label htmlFor="client_store">
                              Preferred Store{" "}
                              <span className="required">*</span>
                            </label>
                            <select
                              name="client_store"
                              className={
                                CONFIG.DATA.THEME === 2
                                  ? "form-control theme2"
                                  : "form-control"
                              }
                              id="client_store"
                              onChange={(e) => this.changeHandler(e)}
                            >
                              <option value="">Select</option>
                              {this.state.stores.map((value, index) => (
                                <option key={index} value={value.ClientStoreId}>
                                  {value.ClientStoreName}
                                </option>
                              ))}
                            </select>
                          </p>
                          <p className="text-left">
                            <span className="text-danger display-block">
                              {this.validator.message(
                                "Preferred Store",
                                this.state.formControls.client_store,
                                "required"
                              )}
                            </span>
                          </p>

                          <p className="form-group form-row form-row-wide">
                            <label htmlFor="username">
                              Email Address <span className="required">*</span>
                            </label>
                            <input
                              className="input-text form-control"
                              type="email"
                              name="username"
                              id="username"
                              onChange={(e) => this.changeHandler(e)}
                              autoComplete="nope"
                            />
                            <span className="text-danger">
                              {this.validator.message(
                                "Email Address",
                                this.state.formControls.username,
                                "required|email"
                              )}
                            </span>
                          </p>

                          {CONFIG.DATA.ALLOW_PASSWORD ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesfoodking" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesmarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessupersave" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessignature" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "superiorgrocers" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "market33" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "fiestafoodsamarillo" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "topvaluecostplus" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "pandlcountrymarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN ===
                            "bradfordgeneralstore" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lagreesfoodstores" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "mcdanielpw" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "kirbyfoods" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "vowellsmarketplace" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw" ? (
                            <React.Fragment>
                              <p className="form-group form-row form-row-wide">
                                <label htmlFor="password">
                                  Password (Password 6-12 characters){" "}
                                  <span className="required">*</span>
                                </label>
                                <input
                                  className="input-text form-control"
                                  type="password"
                                  minLength="6"
                                  maxLength="12"
                                  name="password"
                                  id="password"
                                  onChange={(e) => this.handleChangePassword(e)}
                                  autoComplete="nope"
                                />
                              </p>

                              {/* <p className="text-left">
                                                              <span className='text-danger'>{this.validator.message('password', this.state.formControls.password, 'required')}</span>
                                                          </p> */}

                              <span
                                className="text-danger"
                                style={{ display: "flex" }}
                              >
                                {!!this.state.errors ? (
                                  this.state.errors.statusCode === "error" ? (
                                    <span>{this.state.errors.msg}</span>
                                  ) : this.state.errors.statusCode ===
                                    "missing" ? (
                                    <span>{this.state.errors.msg}</span>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                              </span>

                              <p className="form-group form-row form-row-wide">
                                <label htmlFor="repassword">
                                  Confirm Password{" "}
                                  <span className="required">*</span>
                                </label>
                                <input
                                  className="input-text form-control"
                                  type="password"
                                  minLength={6}
                                  pattern="/^(?=^.{6,}$)^[a-zA-Z0-9_@./#&+-]*$/"
                                  maxLength={12}
                                  name="repassword"
                                  id="repassword"
                                  onChange={(e) => this.changeHandler(e)}
                                />

                                <samp className="text-danger">
                                  {this.validator.message(
                                    "repassword",
                                    this.state.formControls.repassword,
                                    `required|in:${this.state.formControls.password}`,
                                    {
                                      messages: {
                                        in: "Passwords need to match!",
                                      },
                                    }
                                  )}
                                </samp>
                              </p>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <p className="form-group form-row form-row-wide">
                                <label htmlFor="password">
                                  PIN (4 digit number){" "}
                                  <span className="required">*</span>
                                </label>
                                <input
                                  className="input-text form-control"
                                  type="password"
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  maxLength="4"
                                  minLength="4"
                                  name="password"
                                  id="password"
                                  onChange={(e) => this.changeNumericHandler(e)}
                                  value={this.state.formControls.password}
                                />
                              </p>
                              <p className="text-left">
                                <span className="text-danger">
                                  {this.validator.message(
                                    "pin",
                                    this.state.formControls.password,
                                    "required|min:4"
                                  )}
                                </span>
                              </p>

                              <div className="form-group form-row form-row-wide">
                                <label htmlFor="repassword">
                                  Re-enter PIN{" "}
                                  <span className="required">*</span>
                                </label>
                                <input
                                  className="input-text form-control"
                                  type="password"
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  maxLength="4"
                                  name="repassword"
                                  id="repassword"
                                  onChange={(e) => this.changeNumericHandler(e)}
                                  value={this.state.formControls.repassword}
                                />
                                <samp className="text-danger">
                                  {this.validator.message(
                                    "Re-enter pin ",
                                    this.state.formControls.repassword,
                                    `required|min:4|in:${this.state.formControls.password}`,
                                    {
                                      messages: {
                                        in: "Passwords need to match!",
                                      },
                                    }
                                  )}
                                </samp>
                              </div>
                            </React.Fragment>
                          )}

                          <div
                            className="wpforms-submit-container mb-2 employmentcheckbox float-left "
                            style={{ color: "#000" }}
                          >
                            <p>
                              <input
                                type="checkbox"
                                onChange={(e) => this.changeCheckboxHandler(e)}
                                value="1"
                                name="terms"
                                className="wpforms-field-medium "
                              />{" "}
                              I agree to the {CONFIG.DATA.RSA_CLIENT_APP_NAME}{" "}
                              <a
                                href="/company-policies/terms-and-conditions"
                                target="_blank"
                              >
                                Terms and Conditions
                              </a>
                            </p>
                            <div className="text-danger text-left ">
                              {this.validator.message(
                                "Terms and Conditions ",
                                this.state.formControls.terms,
                                "required"
                              )}
                            </div>
                          </div>

                          <div className="ReCAPTCHA">
                            <ReCAPTCHA
                              style={{ display: "block" }}
                              theme="light"
                              sitekey="6LebzrYUAAAAAIo_0vP7bjbtzzBTKNlC4UvyEGKU"
                              onChange={this.handleChange}
                              asyncScriptOnLoad={this.asyncScriptOnLoad}
                            />

                            <br />
                            <p
                              className="text-danger text-center"
                              style={{ marginTop: "10px" }}
                            >
                              {this.validator.message(
                                "captcha",
                                this.state.formControls.Captcha,
                                "required"
                              )}
                            </p>
                          </div>

                          <div className="form-group form-row">
                            <div className="form-group clearfix"></div>
                            <input
                              type="button"
                              id="register_button"
                              className="woocommerce-Button button btn btn-theme btn-block"
                              name="login"
                              value="Register"
                              onClick={(e) => this.Register(e)}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Register;
